/**
 * Shared Abacus registration-tile display rules (spec 072 FR-008–FR-010).
 * Used by student `/register-course` and parent child-registration tiles.
 */

export type AbacusTileDisplay = 'available' | 'teaser' | 'enrolled' | 'coming-soon';

export interface AbacusTileDisplayInput {
  courses?: unknown[] | null;
  comingSoonTeaser?: { id: number; name: string } | null;
  enrolledCourse?: { id: number; name: string } | null;
}

/**
 * Maps a tile payload to the four UI states. Precedence: enrolled, then enrollable
 * `courses[]`, then named COMING_SOON teaser, else generic coming soon.
 */
export function resolveAbacusTileDisplay(tile: AbacusTileDisplayInput | undefined): AbacusTileDisplay {
  if (!tile) {
    return 'coming-soon';
  }
  if (tile.enrolledCourse) {
    return 'enrolled';
  }
  if ((tile.courses?.length ?? 0) > 0) {
    return 'available';
  }
  if (tile.comingSoonTeaser) {
    return 'teaser';
  }
  return 'coming-soon';
}

/** Chip copy on student registration tiles. */
export function studentAbacusChipLabel(display: AbacusTileDisplay): string {
  if (display === 'enrolled') {
    return 'Already enrolled';
  }
  if (display === 'available') {
    return 'Available';
  }
  return 'Coming Soon';
}

/** Chip copy on parent child-registration tiles. */
export function parentAbacusChipLabel(display: AbacusTileDisplay): string {
  if (display === 'enrolled') {
    return 'Already enrolled';
  }
  if (display === 'available') {
    return 'Available';
  }
  return 'Coming soon';
}
